import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { PlanType } from "../../domain/models/plan-type";
import { PlanTypeRepository } from "../../repositories/plan-type.repository";

@Injectable({ providedIn: 'root' })
export class GetPlanTypeUsecase implements UseCase<null, PlanType[]> {

  constructor(private readonly planTypeRepository: PlanTypeRepository) {
  }

  execute(): Observable<PlanType[]> {
    return this.planTypeRepository.getPlanTypes();
  }

}
